import { useContext } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import SoftButton from "components/SoftButton";
import { updateQuery } from "api/UdasWrapper";
import { useAuth0 } from "@auth0/auth0-react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { TenantContext } from "context/AppProvider/TenantContext";
import { UserContext } from "context/AppProvider/UserContext";
import { setUsers } from "redux/actions/portal/usersActionCreator";

function RemovePictureModal({
  openRemovePictureModal,
  setOpenRemovePictureModal,
  setCompanyLogo,
  setUserAvatar,
  setLogoKey,
  targetUser,
  targetTenant
}) {
  const { user } = useAuth0();
  const { pathname } = useLocation();
  const { tenantData, setTenantLogo, setTenantData } = useContext(TenantContext);
  const { userData, setUserData } = useContext(UserContext);
  const { users } = useSelector((store) => store.portal.users);
  const dispatch = useDispatch();

  const handleClose = () => {
    setOpenRemovePictureModal(false);
  };

  const getMutationSuccess = (response, fieldName) =>
    response?.[fieldName]?.isSuccessful ??
    response?.data?.[fieldName]?.isSuccessful ??
    response?.isSuccessful ??
    false;

  const handleRemovePicture = async () => {
    const activeUser = targetUser || userData || {};
    const activeTenant = targetTenant || tenantData || {};
    const auth0Id = activeUser?.auth0_id || user?.cxfUserId;
    const tenantId = activeUser?.tenant_id || activeTenant?.tenant_id || user?.stripeId;

    if (pathname === "/administration/company") {
      const data = JSON.stringify({
        query: `mutation UpdateCompanyLogo($tenant_id: String!, $image: String!) {
          updateCompanyLogo(tenant_id: $tenant_id, image: $image) {
            isSuccessful
            message
            resultObject
          }
        }`,
        variables: { tenant_id: `${tenantId}`, image: "" }
      });

      try {
        const response = await updateQuery(data);

        if (!getMutationSuccess(response, "updateCompanyLogo")) {
          toast.error("Failure to remove image");
          return;
        }

        setCompanyLogo("");
        if (setLogoKey) {
          setLogoKey(null);
        }
        setTenantData((prev) => ({
          ...prev,
          logo_url: ""
        }));
        setTenantLogo("");
        toast.success("Image removed successfully!");
      } catch (error) {
        console.log(error);
        toast.error("Failure to remove image");
        return;
      }
    } else {
      const data = JSON.stringify({
        query: `mutation UpdateUserImage($auth0_id: String!, $tenant_id: String!, $image: String!) {
          updateUserImage(auth0_id: $auth0_id, tenant_id: $tenant_id, image: $image) {
            isSuccessful
            message
            resultObject
          }
        }`,
        variables: {
          auth0_id: `${auth0Id}`,
          tenant_id: `${tenantId}`,
          image: ""
        }
      });

      try {
        const response = await updateQuery(data);

        if (!getMutationSuccess(response, "updateUserImage")) {
          toast.error("Failure to remove image");
          return;
        }

        toast.success("Image removed successfully!");
        setUserData((prev) => ({ ...prev, image: "" }));
        setUserAvatar("");
        dispatch(setUsers(users?.map((u) => (u.auth0_id === auth0Id ? { ...u, image: "" } : u))));
      } catch (error) {
        console.log(error);
        toast.error("Failure to remove image");
        return;
      }
    }

    setOpenRemovePictureModal(false);
  };

  return (
    <Dialog open={openRemovePictureModal} onClose={handleClose} aria-labelledby="responsive-dialog-title">
      <DialogTitle id="responsive-dialog-title">Remove Picture</DialogTitle>
      <DialogContent>
        <DialogContentText>Are you sure you want to remove picture?</DialogContentText>
      </DialogContent>
      <DialogActions>
        <SoftButton variant="outlined" color="info" onClick={handleClose}>
          Disagree
        </SoftButton>
        <SoftButton color="info" onClick={handleRemovePicture}>
          Agree
        </SoftButton>
      </DialogActions>
    </Dialog>
  );
}

export default RemovePictureModal;